<template>
	<div>
		<Echart
		  :options="options"
		  id="bottomLeftChartotherChartaq"
		  height="480px"
		  width="100%"
		></Echart>
	</div>
</template>

<script>
import Echart from '@/common/echart' // eslint-disable-line no-unused-vars
export default {
	data () {
	  return {
		  options:{
			 xAxis: {
			 	type: 'category',
			 	data: ['兴安街道', '新安街道', '凌河街道', '景芝镇', '官庄镇', '大盛镇', '石埠子镇', '石堆镇', '拓山镇', '辉渠镇', '吾山镇', '金冢子镇'],
			 	axisLabel:{
			 		interval: 0,    //强制文字产生间隔
			 		rotate: 45, 
			 	}
			 },
			 yAxis: {
			 	type: 'value'
			 },
			 grid: {
			 	x: 50, //控制x轴文字与底部的距离
			 	y2: 100 // y2可以控制倾斜的文字狱最右边的距离，放置倾斜的文字超过显示区域
			 },
			 series: [
			 	{
			 		data: [1836, 1215, 954, 1029, 1069, 972, 1047, 1139, 826, 770, 816, 638],
			 		type: 'bar'
			 	}
			 ]
		  }
	  }
	},
	components: {
	  Echart
	},
}
</script>

<style></style>
